import jQuery from 'jquery';

jQuery(function($) {
  const $body = $('body');
  const $header = $('.header');
  const $nav = $header.find('.header__nav');
  const $navMain = $nav.find('.nav__main');
  const $itemDropdown = $navMain.find('.nav__item--dropdown');
  const $itemDropdownLink = $itemDropdown.find('.nav__item--dropdown > a');
  const $sublistLink = $itemDropdown.find('.nav__list--secondary a');

  $nav.find('.nav__menu').on('click', function() {
    $('body, html').css({ 'overflow': 'hidden' });
    $navMain.addClass('nav__main--active');
  });

  $navMain.find('.nav__close').on('click', function() {
    $('body, html').css({ 'overflow': 'auto' });
    $navMain.removeClass('nav__main--active');
  });

  $itemDropdown.on('click', (event) => {
    if ($body.outerWidth() < 1200) {
      event.preventDefault();

      const $target = $(event.currentTarget);

      const $subList = $target.find('.nav__list--secondary');
      $subList.toggleClass('nav__list--secondary--active');
    }
  });

  $itemDropdownLink.on('click', (event) => {
    if ($body.outerWidth() < 1200) {
      event.preventDefault();
    }
  });

  $sublistLink.on('click', (event) => {
    if ($body.outerWidth() < 1200) {
      event.stopPropagation();
    }
  });

  /* Floating header */
  let $headerTop = $header.find('.header__top');
  let $headerBottom = $header.find('.header__bottom');

  $header.css({ 'height': $header.height() });

  $(window).on('scroll', function() {
    let currentTop = Math.round($(this).scrollTop());
    let headerTopBottom = Math.round($headerTop.offset().top + $headerTop.height());

    if (currentTop > headerTopBottom) {
      $headerBottom.css({ 'top': '-100%' });
      $headerBottom.addClass('header__bottom--fixed');
      $headerBottom.css({ 'top': 0 });
      $header.find('.header__logo-phone, .header__logo-email').removeClass('d-none');
    } else {
      $headerBottom.removeClass('header__bottom--fixed');
      $header.find('.header__logo-phone, .header__logo-email').addClass('d-none');
    }
  });

  $(window).trigger('scroll');
});
